import React from 'react';
import PropTypes from 'prop-types';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDProgress from 'components/MDProgress';

const ProductionCardFooter = ({ createdAt, onView, onEdit, completionPercentage, getProgressColor, aaroFields }) => {
    // Format date
    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric' });
    };

    // Function to determine progress bar color based on percentage
    const getBarColor = (value) => {
        if (value < 30) return 'error';
        if (value < 70) return 'warning';
        return 'success';
    };

    // Get production and shipment rates as numbers
    const productionRate = parseFloat(aaroFields?.UretimOrani) || 0;
    const shipmentRate = parseFloat(aaroFields?.SevkiyatOrani) || 0;

    // Ensure completion percentage is a number
    const taskCompletionPercentage = completionPercentage || 0;

    // Calculate average of three percentages for overall health
    //  const overallHealth = (productionRate + shipmentRate + taskCompletionPercentage) / 3;

    return (
        <MDBox>
            {/* Minimal metrics display in a single line */}
            <MDBox display="flex" justifyContent="flex-start" alignItems="center" mb={1}>
                <MDTypography variant="caption" color="text" fontWeight="regular" fontSize="0.65rem">
                    Üretim: %{productionRate.toFixed(0)} | Sevk: %{shipmentRate.toFixed(0)} | Görev:{' '}
                    <span style={{ color: getColorValue(getProgressColor(taskCompletionPercentage)) }}>
                        %{taskCompletionPercentage.toFixed(0)}
                    </span>
                </MDTypography>
            </MDBox>

            {/* Overall progress bar */}
            <MDProgress
                value={taskCompletionPercentage.toFixed(0)}
                color={getBarColor(taskCompletionPercentage.toFixed(0))}
                variant="gradient"
                label={false}
                sx={{ height: '3px' }}
            />
        </MDBox>
    );
};

// Helper function to get the CSS color value based on semantic color names
const getColorValue = (colorName) => {
    const colors = {
        error: '#f44335',
        warning: '#fb8c00',
        success: '#4caf50',
        info: '#1976d2',
    };
    return colors[colorName] || colors.info;
};

ProductionCardFooter.propTypes = {
    createdAt: PropTypes.string,
    onView: PropTypes.func,
    onEdit: PropTypes.func,
    completionPercentage: PropTypes.number,
    getProgressColor: PropTypes.func,
    aaroFields: PropTypes.object,
};

ProductionCardFooter.defaultProps = {
    createdAt: '',
    onView: () => {},
    onEdit: () => {},
    completionPercentage: 0,
    getProgressColor: (value) => 'info',
    aaroFields: {},
};

export default ProductionCardFooter;
